window.addEventListener("load", () => {
  (() => {
    const linkMenu =
      document.getElementById("blog-home-links-menu") ||
      document.getElementById("blog-page-links-menu");
    let pos = { left: 0, x: 0 };

    function mouseDownHandler(e) {
      pos = {
        left: linkMenu.scrollLeft,
        x: e.clientX,
      };
      console.log(pos);
      document.addEventListener("mousemove", mouseMoveHandler);
      document.addEventListener("mouseup", mouseUpHandler);
    }

    function mouseMoveHandler(e) {
      const deltaX = e.clientX - pos.x;
      linkMenu.scrollLeft = pos.left - deltaX;
    }

    function mouseUpHandler() {
      document.removeEventListener("mousemove", mouseMoveHandler);
      document.removeEventListener("mouseup", mouseUpHandler);
    }

    linkMenu.addEventListener("mousedown", mouseDownHandler);
  })();

  (() => {

    let navPipContainers = document.querySelectorAll('.mobile-nav')
    let navPips = document.querySelectorAll(".blog-mobile-nav-pip");
    let galleries = document.querySelectorAll(".blog-article-gallery");

      if ("ontouchstart" in document.documentElement) {
       navPipContainers.forEach(container => {
        container.style.display=  'none';
       })
       
       galleries.forEach(gallery => {
        gallery.style.overflowX = 'scroll';
       })

      }
      else {
        navPipContainers.forEach(container => {
          container.style.display=  'block';})

          galleries.forEach(gallery => {
            gallery.style.overflowX = 'visible';
           })
    
      }
     

  


    function getTranslateX(elem) {
      let style = window.getComputedStyle(elem);
      let matrix = new WebKitCSSMatrix(style.transform);
      console.log("translateX: ", matrix.m41, typeof matrix.m41);
      return matrix.m41;
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth > 576) {
        galleries.forEach((gallery) => {
          gallery.style.transform = "translateX(0)";
          let active = generateActiveClass(gallery);
          let pipContainer =
            gallery.parentElement.parentElement.parentElement.querySelector(
              ".mobile-nav"
            );
          let pips = pipContainer.querySelectorAll(".blog-mobile-nav-pip");
          pips.forEach((pip) => {
            pip.classList.contains(active)
              ? pip.classList.remove(active)
              : null;
          });
          if (pips.length) {
            pips[0].classList.add(active);
          }
        });
      }
    });

    function generateActiveClass(gallery) {
      let pipsContainer =
        gallery.parentElement.parentElement.parentElement.querySelector(
          ".mobile-nav"
        );
      let btnClassSuffix;

      let pipParentId = parseInt(pipsContainer.classList[0].replace(/\D/g, ""));

      if (pipParentId == 1 || pipParentId == 5) {
        btnClassSuffix = "-one";
      } else if (pipParentId == 2 || pipParentId == 6) {
        btnClassSuffix = "-two";
      } else if (pipParentId == 3 || pipParentId == 7) {
        btnClassSuffix = "-three";
      } else if (pipParentId == 4 || pipParentId == 8) {
        btnClassSuffix = "-four";
      }
      let active = `btn${btnClassSuffix}`;
      return active;
    }

    function setActivePip(direction, gallery) {
      let activePip;
      let pipsContainer =
      gallery.parentElement.parentElement.parentElement.querySelector(
        ".mobile-nav"
      );
      let activeClass = generateActiveClass(gallery);

      activePip = pipsContainer.querySelector(`.${activeClass}`);

      if (activePip.nextElementSibling && direction == "left") {
        setTimeout(() => {
          activePip.nextElementSibling.classList.add(activeClass);
          activePip.classList.remove(activeClass);
        }, 50);
      } else if (activePip.previousElementSibling && direction == "right") {
        activePip.previousElementSibling.classList.add(activeClass);
        activePip.classList.remove(activeClass);
      }
    }

    for (let pip of navPips) {
      pip.addEventListener("click", (e) => {
        console.log("clicked pip");
        let targetPip = e.target;
        let pipParentId = parseInt(
          targetPip.parentElement.classList[0].replace(/\D/g, "")
        );
        let pipTotal = targetPip.parentElement.querySelectorAll(
          ".blog-mobile-nav-pip"
        ).length;
        let scrollElem = targetPip.parentElement.parentElement.querySelector(
          ".blog-article-gallery"
        );
        let scrollIncrement = scrollElem.firstElementChild.offsetWidth;
        let targetPipId = parseInt(targetPip.classList[2].replace(/\D/g, ""));
        let btnClassSuffix;

        if (pipParentId == 1 || pipParentId == 5) {
          btnClassSuffix = "-one";
        } else if (pipParentId == 2 || pipParentId == 6) {
          btnClassSuffix = "-two";
        } else if (pipParentId == 3 || pipParentId == 7) {
          btnClassSuffix = "-three";
        } else if (pipParentId == 4 || pipParentId == 8) {
          btnClassSuffix = "-four";
        }

        let btnClass = `btn${btnClassSuffix}`;

        if (targetPip.classList.contains(btnClass)) {
          return;
        } else {
          navPips.forEach((navPip) => {
            navPip.classList.remove(btnClass);
          });
          targetPip.classList.add(btnClass);
          console.log(
            targetPip,
            targetPipId,
            scrollIncrement,
            scrollElem,
            scrollElem.scrollLeft,
            pipParentId,
            btnClass
          );

          if (targetPipId === 1) {
            scrollElem.style.transform = `translateX(0)`;
          } else if (targetPipId === pipTotal) {
            scrollElem.style.transform = `translateX(${
              -scrollIncrement * 2
            }px)`;
          } else {
            scrollElem.style.transform = `translateX(${-scrollIncrement}px)`;
          }
        }
      });
    }
  })();


  (() => {
    if (window.location.href.includes("blogs")) {
      return;
    } else {
      let wideCols = document.querySelectorAll(".wide");
      setHeight();
      window.addEventListener("resize", () => {
        setHeight();
      });

      function setHeight() {
        let standardImgHeight = document
          .querySelector(".standard")
          .querySelector("img").offsetHeight;
        for (let col of wideCols) {
          let img = col.querySelector("img");
          img.style.height = `${standardImgHeight}px`;
        }
      }
    }
  })();

  
});
